import { Component, ElementRef, HostBinding, OnInit } from '@angular/core';

import { FormBuilder, FormControl, FormGroup } from '@angular/forms';

import { ActivatedRoute, Router } from '@angular/router';

import { NotificationService } from 'src/app/Service/notification.service';

import { OtherService } from 'src/app/Service/other.service';

import { GurdServiceService } from 'src/app/Service/gurd-service.service';

import axios from 'src/app/Service/axios';

import * as XLSX from 'xlsx';
import { Chart } from 'chart.js';

declare let $: any;

@Component({

  selector: 'app-service-parts',

  templateUrl: './service-parts.component.html',

  styleUrls: ['./service-parts.component.css']

})

export class ServicePartsComponent implements OnInit {

  list_Subject = [];

  list_Status = [];

  list_Result: any = [];

  list_FullResult = [];

  list_Proceeding: any = [];

  list_Proceeding_Search: any = [];

  bNewAction: boolean = false;

  bSearch4Car: boolean = false;

  editMode: boolean = false;

  objService: any = {};

  acssess: any;

  obj1: any;

  label1: Array<any> = [];

  datachart1: Array<any> = [];

  ctx1: any;

  obj2: any;

  label2: Array<any> = [];

  datachart2: Array<any> = [];

  ctx2: any;

  CHART_COLORS1: any = {
    green: 'rgb(111, 255, 111)',
    purple: 'rgb(255, 153, 204)',
    blue: 'rgb(29, 179, 214)',
    orange: 'rgb(45, 103, 103)',
    yellow: 'rgb(251, 101, 150)',
    red: 'rgb(36, 123, 46)',
    grey: 'rgb(103, 13, 183)',
  };

  searchModel: FormGroup = this.formBuilder.group({

    iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

    strSession: this.gurdService.decrypt(window.localStorage.getItem('Session')!),

    tiServiceParts_Subject: new FormControl(-1),

    tiServiceParts_Status: new FormControl(-1),

    strUnitID: new FormControl(''),

  })

  saveModel: FormGroup = this.formBuilder.group({

    iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

    strSession: this.gurdService.decrypt(window.localStorage.getItem('Session')!),

    iServiceParts_Request: new FormControl(""),

    tiServiceParts_Status: new FormControl(-1),

    strComment: new FormControl(""),

  })

  saveModel_Car: FormGroup = this.formBuilder.group({

    iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

    strSession: this.gurdService.decrypt(window.localStorage.getItem('Session')!),

    iServiceParts_Request: new FormControl(''),

    strUnitID: new FormControl(''),

    tiServiceParts_Subject: new FormControl(-1),

    strComment: new FormControl(''),

    strValue: new FormControl(''),

    fLat: new FormControl(0),

    fLon: new FormControl(0),

    strImage: new FormControl(''),

  })

  constructor(

    private notifyService: NotificationService,

    private router: Router,

    public otherService: OtherService,

    private route: ActivatedRoute,

    private formBuilder: FormBuilder,

    private gurdService: GurdServiceService

  ) { }

  ngOnInit(): void {

    var data = window.localStorage.getItem("menu") as any;

    this.acssess = JSON.parse(this.gurdService.decrypt(data));

    this.route.params.subscribe(params => {

      if (params['id']) {

        this.searchModel.controls['strUnitID'].setValue(params['id']);

        this.saveModel_Car.controls['strUnitID'].setValue(params['id']);

        this.getResult_4car();

      }

      if (!params['id'] && !this.acssess.bServiceParts_Manage) {

        this.notifyService.showError('شما دسترسی به این صفحه را ندارید');

        this.router.navigate(['/'])

      }

    });

    this.getAllSubject();

    this.getAllStatus();

  }

  keyWord_Search(key: any) {

    this.list_Result = this.list_FullResult.filter((el: any) => {

      return el.iServiceParts_Request.toString().includes(key.value) ||

        el.strServiceParts_Subject_strComment.includes(key.value) ||

        el.strVehicleNo.includes(key.value) ||

        el.strFullName.includes(key.value) ||

        el.strServiceParts_Status_strComment.includes(key.value);

    });

    if (key.value == '') this.list_Result = this.list_FullResult;

  }

  keyWord_Search_Proceeding(key: any) {

    this.list_Proceeding = this.list_Proceeding_Search.filter((el: any) => {

      return el.strFullName.toString().includes(key.value) ||

        el.strServiceParts_Status_strComment.includes(key.value) ||

        el.strComment.includes(key.value)

    });

    if (key.value == '') this.list_Proceeding = this.list_Proceeding_Search;

  }

  getAllSubject = async () => {

    this.otherService.Showspinner();

    const response = await axios.post(`ServiceParts_Subject_List`);

    let res = JSON.parse(response.data);

    this.list_Subject = res;

    this.otherService.nonespinner()

  }

  getAllStatus = async () => {

    this.otherService.Showspinner();

    const response = await axios.post(`ServiceParts_Status_List`);

    let res = JSON.parse(response.data);

    this.list_Status = res;

    this.otherService.nonespinner()

  }

  getResult = async () => {

    this.otherService.Showspinner();

    const response = await axios.post(`ServiceParts_Request_List`, this.searchModel.value);

    let res = JSON.parse(response.data);

    this.list_Result = res;

    this.list_FullResult = res;

    this.otherService.nonespinner()

  }

  openView_Modal = async (item: any) => {

    var model = {

      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(window.localStorage.getItem('Session')!),

      iServiceParts_Request: item.iServiceParts_Request

    }

    this.otherService.Showspinner();

    const response = await axios.post(`ServiceParts_Proceeding_List`, model);

    const response_2 = await axios.post(`ServiceParts_Request_ORG_Info`, model);

    this.saveModel.controls['iServiceParts_Request'].setValue(item.iServiceParts_Request);

    this.bNewAction = false;

    let res = JSON.parse(response.data);

    let res_2 = JSON.parse(response_2.data);

    this.list_Proceeding = res;

    this.list_Proceeding_Search = res;

    this.objService = res_2[0];

    this.otherService.nonespinner()

    $("#ViewInfo_Modal").modal('show')

  }

  submitAction = async () => {

    if (this.saveModel.get('tiServiceParts_Status')?.value == -1 || this.saveModel.get('strComment')?.value.trim() == "") return this.notifyService.showError('لطفا موارد ضروری را وارد کنید');

    this.otherService.Showspinner();

    const response = await axios.post(`ServiceParts_Proceeding_Save`, this.saveModel.value);

    let res = JSON.parse(response.data);

    if (res.bError || res.iResult == 0) return this.notifyService.showError(res.strError);

    this.list_Proceeding.push(res[0]);

    this.bNewAction = false;

    this.saveModel.patchValue({

      iServiceParts_Request: new FormControl(""),

      tiServiceParts_Status: new FormControl(-1),

      strComment: new FormControl(""),

    })

    this.otherService.nonespinner()

  }

  remove_Service_Part = async (item: any, index: number) => {

    $.confirm({

      title: `آیا از حذف اطمینان دارید ؟`,

      content: '',

      type: 'red',

      buttons: {

        ok: {

          text: "حذف",

          btnClass: 'btn-danger',

          keys: ['enter'],

          action: async () => {

            var model = {

              iServiceParts_Request: item.iServiceParts_Request,

              iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

              strSession: this.gurdService.decrypt(window.localStorage.getItem('Session')!),

            }

            this.otherService.Showspinner();

            const resp = await axios.post(`ServiceParts_Request_Delete`, model);

            this.otherService.nonespinner();

            let res = JSON.parse(resp.data);

            if (res.bError) return this.notifyService.showError(res.strError);

            this.list_Result.splice(index, 1);

            return this.notifyService.showSuccess('اطلاعات با موفقیت حذف شد');

          }

        },

        cancel: {

          text: "لغو",


        }

      }

    });

  }

  fullScreen_Image() {

    const image_Element = $("#fullScreen_");

    image_Element.toggleClass('full-screen');

  }

  showOnMap(item: any) {

    if (item.fLat == 0 || item.fLon == 0) return this.notifyService.showError('مشخصات موقعیت یافت نشد');

    var model = {

      strDate: '',

      strAddress: '',

      strSTime: '',

      strETime: '',

      strParkTime: '',

    };

    localStorage.setItem('ddval', '');

    window.localStorage.setItem('StopModel', this.gurdService.encrypt(JSON.stringify(model)));

    window.localStorage.setItem('fLat', this.gurdService.encrypt(item.fLat));

    window.localStorage.setItem('fLon', this.gurdService.encrypt(item.fLon));

    window.open('/stopMap', '_blank')


  }

  // =============================================

  getResult_4car = async () => {

    this.otherService.Showspinner();

    const response = await axios.post(`ServiceParts_Request_List4Car`, this.searchModel.value);

    let res = JSON.parse(response.data);

    this.list_Result = res;

    this.list_FullResult = res;

    this.bSearch4Car = true;

    this.otherService.nonespinner()

  }

  open_RequestModal() {

    this.editMode = false;

    this.saveModel_Car.patchValue({

      tiServiceParts_Subject: -1,

      strComment: '',

      strValue: '',

      fLat: 0,

      fLon: 0,

      strImage: '',

    })

    $("#newRequest_Modal").modal('show');

  }

  openEdit_Modal = async (item: any) => {

    this.saveModel_Car.get('iServiceParts_Request')?.setValue(item.iServiceParts_Request)

    this.otherService.Showspinner();

    const response = await axios.post(`ServiceParts_Request_ORG_Info`, this.saveModel_Car.value);

    let res = JSON.parse(response.data);

    this.otherService.nonespinner()

    this.editMode = true;

    Object.keys(res[0]).forEach((key: any) => {

      this.saveModel_Car.get(key)?.setValue(res[0][key])

    })

    $("#newRequest_Modal").modal('show');


  }

  onFileInput(file: any) {

    let extension = file.name.split('.').pop();

    if (extension !== 'jpeg' && extension !== 'jpg') this.notifyService.showError(' فرمت قابل قبول فقط jpg است')

    if (extension === 'jpeg' || extension === 'jpg') {

      const reader: any = new FileReader();

      reader.readAsDataURL(file);

      reader.onload = async () => {

        var base64String = reader.result.toString();

        base64String = base64String.replace('data:image/jpeg;base64,', '');

        this.saveModel_Car.controls['strImage'].setValue(base64String)

      };

    }

  }

  saveService = async () => {

    var model = this.saveModel_Car.value;

    if (model.tiServiceParts_Subject == -1) return this.notifyService.showError('لطفا موضوع را مشخص کنید');

    if (model.strValue == '') return this.notifyService.showError('لطفا مقدار را وارد کنید');

    $.confirm({

      title: `آیا از ثبت درخواست اطمینان دارید ؟`,

      content: '',

      type: 'green',

      buttons: {

        ok: {

          text: "ثبت",

          btnClass: 'btn-success',

          keys: ['enter'],

          action: async () => {

            this.otherService.Showspinner();

            const response = await axios.post(`ServiceParts_Request_Save`, this.saveModel_Car.value);

            let res = JSON.parse(response.data);

            if (res.bError) return this.notifyService.showError(res.strError)

            this.list_Result.push(res[0])

            this.otherService.nonespinner();

            $("#newRequest_Modal").modal('hide');

          }

        },

        cancel: {

          text: "لغو",

        }

      }

    });

  }

  editService = async () => {

    var model = this.saveModel_Car.value;

    if (model.tiServiceParts_Subject == -1) return this.notifyService.showError('لطفا موضوع را مشخص کنید');

    if (model.strValue == '') return this.notifyService.showError('لطفا مقدار را وارد کنید');

    $.confirm({

      title: `آیا از ویرایش اطلاعات اطمینان دارید ؟`,

      content: '',

      type: 'blue',

      buttons: {

        ok: {

          text: "ویرایش",

          btnClass: 'btn-primary',

          keys: ['enter'],

          action: async () => {

            this.otherService.Showspinner();

            const response = await axios.post(`ServiceParts_Request_Edit`, this.saveModel_Car.value);

            let res = JSON.parse(response.data);

            const itemsValue = this.list_Result.filter((el: any, index: number) => {

              return el.iServiceParts_Request == res[0].iServiceParts_Request

            })

            const index = this.list_Result.indexOf(itemsValue[0]);

            if (index != -1) this.list_Result[index] = res[0]

            this.otherService.nonespinner();

            $("#newRequest_Modal").modal('hide');

          }

        },

        cancel: {

          text: "لغو",

        }

      }

    });

  }

  exportexcel(id: any): void {
    /* pass here the table id */
    let element = document.getElementById(`${id}`);
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, 'service-parts.xlsx');
  }

  showChart = async () => {

    this.otherService.Showspinner();

    await this.getServiceParts();

    await this.getServiceParts_2();

    this.otherService.nonespinner();

    $("#Chart_Modal").modal('show');

  }

  getServiceParts = async () => {

    var model = {

      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!)

    };

    const resp = await axios.post(`ServiceParts_Request_Dashboard_Status`, model);

    let resParse = JSON.parse(resp.data);

    if (resParse.iResult == 0) {

      this.notifyService.showError(resParse.strError);

      return;

    }

    if (resParse.ISSessionExpired == true) {

      this.notifyService.showError('لطفا وارد سیستم شوید');

      this.otherService.removeLocalStorage();

      this.router.navigate(['login'], { queryParams: { error: '5xx7' } });

      return;

    }

    this.obj1 = resParse;

    this.obj1.forEach((element: any) => {

      this.label1.push(element.X);

      this.datachart1.push(element.Y);

    });

    var canvas = document.getElementById("myChart1") as any;

    var ctx = canvas.getContext("2d");

    const DATA_COUNT = 5;

    const data = {

      labels: this.label1,

      datasets: [

        {
          data: this.datachart1,

          backgroundColor: Object.values(this.CHART_COLORS1),

        },

      ],

    } as any;

    if (this.ctx1) {

      this.ctx1.destroy();

    }

    this.ctx1 = new Chart(ctx, {

      type: 'pie',

      data: data,

    });

    var chartEl = document.getElementById("myChart1") as any;

    chartEl.height = 200;

  }

  getServiceParts_2 = async () => {

    var model = {

      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!)

    };

    const resp = await axios.post(`ServiceParts_Request_Dashboard_Subject`, model);

    let resParse = JSON.parse(resp.data);

    if (resParse.iResult == 0) {

      this.notifyService.showError(resParse.strError);

      return;

    }

    if (resParse.ISSessionExpired == true) {

      this.notifyService.showError('لطفا وارد سیستم شوید');

      this.otherService.removeLocalStorage();

      this.router.navigate(['login'], { queryParams: { error: '5xx7' } });

      return;

    }

    this.obj2 = resParse;

    this.obj2.forEach((element: any) => {

      this.label2.push(element.X);

      this.datachart2.push(element.Y);

    });

    var canvas = document.getElementById("myChart2") as any;

    var ctx = canvas.getContext("2d");

    const DATA_COUNT = 5;

    const data = {

      labels: this.label2,

      datasets: [

        {
          data: this.datachart2,

          backgroundColor: Object.values(this.CHART_COLORS1),

        },

      ],

    } as any;

    if (this.ctx2) {

      this.ctx2.destroy();

    }

    this.ctx2 = new Chart(ctx, {

      type: 'pie',

      data: data,

    });

    var chartEl = document.getElementById("myChart2") as any;

    chartEl.height = 100;

  }

}
